import React from 'react';
import { useTheme } from 'styled-components';

const BriefCaseIcon = ({ size = '12', color, fillOpacity }) => {
  const theme = useTheme();
  const fill = color || (theme?.dark ? '#E4E7EC' : '#767476');
  const opacity = fillOpacity ?? (theme?.dark ? '1' : '0.5');
  return (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5436 3.49001C10.1186 3.02001 9.40855 2.78501 8.37855 2.78501H8.25855V2.76501C8.25855 1.92501 8.25855 0.88501 6.37855 0.88501H5.61855C3.73855 0.88501 3.73855 1.93001 3.73855 2.76501V2.79001H3.61855C2.58355 2.79001 1.87855 3.02501 1.45355 3.49501C0.958554 4.04501 0.973554 4.78501 1.02355 5.29001L1.02855 5.32501L1.05601 5.61329C1.07027 5.76307 1.15103 5.89867 1.27748 5.9802C1.39068 6.0532 1.5276 6.13948 1.61855 6.19001C1.68855 6.23501 1.76355 6.27501 1.83855 6.31501C2.69355 6.78501 3.63355 7.10001 4.58855 7.25501C4.63355 7.72501 4.83855 8.27501 5.93355 8.27501C7.02855 8.27501 7.24355 7.73001 7.27855 7.24501C8.29855 7.08001 9.28355 6.72501 10.1736 6.20501C10.2036 6.19001 10.2236 6.17501 10.2486 6.16001C10.4265 6.05942 10.6105 5.93788 10.7819 5.81623C10.876 5.7494 10.9358 5.64477 10.9486 5.53001V5.53001L10.9736 5.29501C10.9786 5.26501 10.9786 5.24001 10.9836 5.20501C11.0236 4.70001 11.0136 4.01001 10.5436 3.49001ZM6.54355 6.91501C6.54355 7.44501 6.54355 7.52501 5.92855 7.52501C5.31355 7.52501 5.31355 7.43001 5.31355 6.92001V6.29001H6.54355V6.91501ZM4.45355 2.78501V2.76501C4.45355 1.91501 4.45355 1.60001 5.61855 1.60001H6.37855C7.54355 1.60001 7.54355 1.92001 7.54355 2.76501V2.79001H4.45355V2.78501Z"
      fill={fill}
      fillOpacity={opacity}
    />
    <path
      d="M10.0326 7.05711C10.3884 6.8936 10.7962 7.17477 10.7608 7.56476L10.6219 9.09511C10.5169 10.0951 10.1069 11.1151 7.90688 11.1151H4.09687C1.89687 11.1151 1.48688 10.0951 1.38188 9.10011L1.25116 7.66228C1.21612 7.27682 1.61453 6.9961 1.96917 7.15115C2.50257 7.38435 3.19767 7.67139 3.70843 7.8217C3.87137 7.86965 4.0031 7.98917 4.08738 8.13663C4.41372 8.70756 5.0473 9.01011 5.93687 9.01011C6.81784 9.01011 7.45821 8.69579 7.78621 8.12184C7.87055 7.97425 8.00228 7.85489 8.16522 7.80641C8.71315 7.64338 9.46515 7.31786 10.0326 7.05711Z"
      fill={fill}
      fillOpacity={opacity}
    />
  </svg>
  );
};

export default BriefCaseIcon;
